import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../../lib/api";

const LINKS = [
  ["how", "How it works"],
  ["signs", "Signs"],
  ["packages", "Packages"],
  ["crew", "The crew"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[var(--cream)]/85 backdrop-blur-md border-b-[3px] border-[var(--ink)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("top")} aria-label="Home">
          <Logo />
        </button>
        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => go(id)}
              className="px-4 py-2 rounded-full font-semibold text-sm hover:bg-[var(--sun)] transition-colors"
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <motion.button
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.95 }}
            data-testid="nav-book-btn"
            onClick={() => go("book")}
            className="sticker-sm rounded-full bg-[var(--coral)] text-white font-display font-semibold px-5 py-2.5 text-sm"
          >
            Book a sign
          </motion.button>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden sticker-sm rounded-full bg-white w-11 h-11 grid place-items-center"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden border-t-[3px] border-[var(--ink)] bg-[var(--cream)]"
          >
            <div className="px-4 py-4 flex flex-col">
              {LINKS.map(([id, label]) => (
                <button
                  key={id}
                  data-testid={`mobile-link-${id}`}
                  onClick={() => go(id)}
                  className="text-left font-display text-2xl font-semibold py-2"
                >
                  {label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
